module.exports = __webpack_public_path__ + "static/media/ruzencova-pout-1902-autor-neznamy.4d39b308.jpg";